
import React from 'react'
import { connect } from 'react-redux'

import MagicGrid from '../shared/MagicGrid'

import { getConfig } from './actions'

const mapStateToProps = redux => ({
    config: redux?.admin?.configuration ?? []
})

class Configuration extends React.Component {
  UNSAFE_componentWillMount () {
    const { dispatch } = this.props
    dispatch(getConfig())
  }

  render () {
    const headers = [
      {
        displayFn: r => r.section,
        title: 'Section'
      },
      {
        displayFn: r => r.display,
        title: 'Option'
      },
      {
        displayFn: r => r.value,
        title: 'Value'
      }
    ]

    const { config } = this.props

    return (
      <div>
        <h1><b>Configuration</b></h1>
        {' '}
        <div className='margin-bottom'> </div>
        <MagicGrid
          rows={config}
          headers={headers}
          canDelete={false}
          itemName='Options'
        />
      </div>
    )
  }
}

export default connect(mapStateToProps)(Configuration)
